const modifyLocales = (locale: string) => {
  return locale.toUpperCase().replace(/([A-Z]+)_([A-Z]+)/, (_, $1, $2) => {
    return `${$2} (${$1.toLowerCase()})`;
  });
};

export { modifyLocales };
